module.exports = __webpack_public_path__ + "static/rmhs-e4fa63f655e5544a7d413164f1d654a6.png";